export const META_DEFAULT_BASE_URL = 'https://www.udemy.com';
export const EVENT_TRACKING_APP_KEY = 'web_main';

export const DEFAULT_REVALIDATE_SECONDS = 60 * 30; // 30 minutes
export const ONE_HOUR = 60 * 60;
export const FOUR_HOURS = ONE_HOUR * 4;
export const ONE_DAY = ONE_HOUR * 24;

// <<Stencil::Block(constants)>>

// <</Stencil::Block>>
